/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `constants` for the Caintra Connect frontend.
 * @module components/SideMenu/constants
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
/** Responsive breakpoints aligned with SideMenu.module.css media queries. */
export const BREAKPOINTS = {
  MOBILE_MAX: 767,
  TABLET_MIN: 768,
  TABLET_MAX: 991,
  SMALL_DESKTOP_MIN: 992,
  LARGE_DESKTOP_MAX: 1440,
  XL_MIN: 1441,
};

/** Fixed width applied to the sidebar when collapsed on tablet/desktop. */
export const COLLAPSED_MENU_WIDTH = "90px";

/** Application route paths referenced by the sidebar navigation. */
export const ROUTES = {
  COMPANY_PROFILE: "/companyProfile",
  COMPANY_EDIT: "/companyEdit",
  COMPANY_CATALOG: "/companyCatalog",
  DIRECTORY: "/directory",
  BUYER_COMPANIES: "/buyerCompanies",
  BUYER_COMPANY_FORM: "/buyerCompanyForm",
  EVENTS: "/events",
  MANAGE_EVENTS: "/manageEvents",
  ADD_EVENT: "/addEvent",
  EVENT_EDIT: "/eventEdit/",
  BUSINESS_EVENTS: "/businessEvents",
  BUSINESS_EVENT_FORM: "/businessEventForm",
  B2B_EVENTS: "/b2bEvents",
  B2B_EVENT_FORM: "/b2bEventForm",
  B2B_EVENT_DETAIL_PREFIX: "/b2bEvent/",
  VIEW_APPOINTMENTS: "/viewAppointments",
  APPOINTMENT_REQUEST: "/appointmentRequest",
  REQUIREMENTS: "/requirements",
  USERS: "/users",
  USER_ROLES: "/userRoles",
  HOME: "/home",
  ATTENDANCE: "/attendance",
  VIRTUAL_EVENTS: "/virtualEvents",
  VIRTUAL_EVENT_FORM: "/virtualEventForm",
  BREAKFAST_EVENTS: "/breakfastEvents",
  BREAKFAST_EVENT_FORM: "/breakfastEventForm",
  CATEGORY_CATALOG: "/categoryCatalog",
  REPORTS: "/reports",
  NOTIFICATION_CENTER: "/notificationCenter",
  HELP: "/help",
  CHAT: "/chat",
  TERMS_AND_CONDITIONS: "/termsAndConditions",
  PRIVACY_POLICY: "/privacyPolicy",
};

/** Navigation context keys used to distinguish similar routes. */
export const CONTEXTS = {
  PROFILE: "profile",
  MY_COMPANY: "myCompany",
  COMPANY_CATALOG: "companyCatalog",
  DIRECTORY: "directory",
  BUYER_COMPANIES: "buyerCompanies",
};
